<template>
    <el-dialog :visible.sync="visible" title="" width="60%" :before-close="handleClose" append-to-body>
        <el-form :model="form" label-width="120px" v-show="needUpdate && viewType !== 'production_asins'">
            <el-form-item label="主卖ASIN">
                <el-input v-model="form.main_seller_asin" placeholder="请输入主卖ASIN" size="mini" style="width: 200px"></el-input>
            </el-form-item>
            <el-form-item label="SKAG关键词">
                <div style="display: flex; align-items: center; gap: 8px; flex-wrap: wrap">
                    <el-input v-model="skagInput" placeholder="输入关键词后点击添加" size="mini" style="width: 220px"></el-input>
                    <el-button size="mini" type="primary" @click="addSkag">添加</el-button>
                    <div style="display:flex;flex-wrap: wrap;gap:6px">
                        <el-tag v-for="(k,i) in skagList" :key="i" closable @close="removeSkag(i)">{{k}}</el-tag>
                    </div>
                </div>
            </el-form-item>
            <el-form-item label="非主卖ASIN">
                <div style="display: flex; align-items: center; gap: 8px; flex-wrap: wrap">
                    <el-input v-model="notMainInput" placeholder="输入ASIN后点击添加(可为空)" size="mini" style="width: 220px"></el-input>
                    <el-button size="mini" type="primary" @click="addNotMain">添加</el-button>
                    <div style="display:flex;flex-wrap: wrap;gap:6px">
                        <el-tag v-for="(a,i) in notMainList" :key="i" closable type="info" @close="removeNotMain(i)">{{a}}</el-tag>
                    </div>
                </div>
            </el-form-item>
        </el-form>

        <div class="mt-4" v-if="viewType === 'production_asins'">
            <el-card class="mb-2" shadow="hover">
                <div style="margin-bottom: 8px; font-weight: 500">主卖ASIN</div>
                <div style="display:flex;flex-wrap: wrap;gap:6px">
                    <el-tag v-for="(m,i) in displayMainList" :key="'m-'+i" type="success">{{ m }}</el-tag>
                    <span v-if="!displayMainList.length" style="color:#909399">无</span>
                </div>
            </el-card>
            <el-card class="mb-2" shadow="hover">
                <div style="margin-bottom: 8px; font-weight: 500">SKAG关键词</div>
                <div style="display:flex;flex-wrap: wrap;gap:6px">
                    <el-tag v-for="(k,i) in displaySkagList" :key="'k-'+i">{{ k }}</el-tag>
                    <span v-if="!displaySkagList.length" style="color:#909399">无</span>
                </div>
            </el-card>
            <el-card class="mb-2" shadow="hover">
                <div style="margin-bottom: 8px; font-weight: 500">非主卖ASIN</div>
                <div style="display:flex;flex-wrap: wrap;gap:6px">
                    <el-tag v-for="(n,i) in displayNotMainList" :key="'n-'+i" type="info">{{ n }}</el-tag>
                    <span v-if="!displayNotMainList.length" style="color:#909399">无</span>
                </div>
            </el-card>
        </div>

        <template slot="footer">
            <div class="dialog-footer" style="display: flex;justify-content: end">
                <el-button @click="visible = false" size="mini">关闭</el-button>
                <el-button type="primary" @click="updateFunc" size="mini" v-show="needUpdate && viewType !== 'production_asins'">更新</el-button>
            </div>
        </template>
    </el-dialog>
</template>

<script>
import * as api from '@/api/advAnalys/advAnalys'

export default {
    name: 'updateCompletedProductionDialog',
    data() {
        return {
            tempData: {},
            visible: false,
            needUpdate: false,
            form: {
                main_seller_asin: '',
            },
            skagInput: '',
            skagList: [],
            notMainInput: '',
            notMainList: [],
            displayItems: [],
            displayMainList: [],
            displaySkagList: [],
            displayNotMainList: [],
            viewType: 'production_asins',
        }
    },
    methods: {
        updateFunc() {
            api.common_update_production_asins({
                id: this.tempData.id, 
                main_seller_asin: this.form.main_seller_asin,
                not_main_seller_asins: this.notMainList,
                skag_keywords: this.skagList
            }).then((res) => {
                if (res.success) {
                    this.$message.success(res.data)
                    this.handleClose(true)
                } else {
                    this.$message.error(res.message)
                }
            }).finally(() => {
                this.loading = false
            })
        },
        // 关闭弹窗
        handleClose(isshow = false) {
            this.visible = false
            this.loading = false
            this.resetForm()
            this.$emit('close-callback', isshow)
        },
        showModal(data, needUpdate, viewType = 'production_asins') {
            this.needUpdate = needUpdate
            this.viewType = viewType
            this.resetForm()
            this.tempData = JSON.parse(JSON.stringify(data))
            // 数据回显：兼容两种结构
            this.displayItems = []
            this.displayMainList = []
            this.displaySkagList = []
            this.displayNotMainList = []
            if (this.tempData.production_asins) {
                try {
                    const pa = typeof this.tempData.production_asins === 'string'
                        ? JSON.parse(this.tempData.production_asins)
                        : this.tempData.production_asins
                    const isNewShape = pa && (pa.main_seller_asin || Array.isArray(pa.not_main_seller_asins) || Array.isArray(pa.skag_keywords))

                    if (this.viewType === 'production_asins') {
                        if (isNewShape) {
                            if (pa.main_seller_asin) this.displayMainList = [pa.main_seller_asin]
                            this.displaySkagList = Array.isArray(pa.skag_keywords) ? [...pa.skag_keywords] : []
                            this.displayNotMainList = Array.isArray(pa.not_main_seller_asins) ? [...pa.not_main_seller_asins] : []
                        } else {
                            Object.keys(pa || {}).forEach(asin => {
                                if (pa[asin] === 1) this.displayMainList.push(asin)
                                else this.displayNotMainList.push(asin)
                            })
                        }
                    } else {
                        // 编辑视图：填充表单与列表
                        if (isNewShape) {
                            this.form.main_seller_asin = pa.main_seller_asin || ''
                            this.skagList = Array.isArray(pa.skag_keywords) ? [...pa.skag_keywords] : []
                            this.notMainList = Array.isArray(pa.not_main_seller_asins) ? [...pa.not_main_seller_asins] : []
                        } else {
                            // 旧结构：{ asin: is_main }
                            const mains = []
                            const notMains = []
                            Object.keys(pa || {}).forEach(asin => {
                                if (pa[asin] === 1) mains.push(asin)
                                else notMains.push(asin)
                            })
                            this.form.main_seller_asin = mains[0] || ''
                            this.notMainList = notMains
                            // 旧结构无 skag 数据
                        }
                    }
                } catch(e) {
                    console.error('解析 production_asins 失败:', e)
                }
            }
            this.visible = true
        },
        addSkag() {
            const v = (this.skagInput || '').replace(/，/g, ',').trim()
            if (!v) return
            v.split(',').map(s=>s.trim()).filter(Boolean).forEach(s=>{
                if (!this.skagList.includes(s)) this.skagList.push(s)
            })
            this.skagInput = ''
        },
        removeSkag(index){
            this.skagList.splice(index,1)
        },
        addNotMain(){
            const v = (this.notMainInput || '').replace(/，/g, ',').trim()
            if (!v) return
            v.split(',').map(s=>s.trim()).filter(Boolean).forEach(s=>{
                if (!this.notMainList.includes(s)) this.notMainList.push(s)
            })
            this.notMainInput = ''
        },
        removeNotMain(index){
            this.notMainList.splice(index,1)
        },
        resetForm() {
            this.form = {
                main_seller_asin: '',
            }
            this.skagInput = ''
            this.skagList = []
            this.notMainInput = ''
            this.notMainList = []
            this.displayItems = []
            this.displayMainList = []
            this.displaySkagList = []
            this.displayNotMainList = []
        }
    }
}
</script>

<style scoped lang="scss">
.mt-4 {
    margin-top: 1rem;
}

.mb-2 {
    margin-bottom: 0.5rem;
}

.text-center {
    text-align: center;
}

.text-gray-500 {
    color: #909399;
}

.text-danger {
    color: #f56c6c;
}
</style>
